import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { YellowButton } from '@/components/button/button';
import { CloseIcon } from '@/components/icons/icons';
import { Modal } from '@/components/modal/modal';
import { theme } from '@/app/common/providers/theme-provider/theme';
const Title = styled(Typography)`
  font-family: var(--font-cooper-light);
  font-style: normal;
  font-weight: 300;
  font-size: 40px;
  line-height: 45px;
  width: 100%;
  text-align: center;
  color: ${theme.palette.common.black};
`;

const SEEN_KEY = 'WelcomeToDashboardSeen';
const SEEN_VALUE = 'true';

export default function WelcomeToDashboard() {
  const [seen, setSeen] = useState(localStorage.getItem(SEEN_KEY) === SEEN_VALUE);

  const close = () => {
    localStorage.setItem(SEEN_KEY, SEEN_VALUE);
    setSeen(true);
  };

  return (
    <Modal open={!seen} icon={<CloseIcon />} fullWidth onClose={close}>
      <Box py={4}>
        <Title variant="h2">Welcome to your host dashboard!</Title>
        <Box pt={4} />
        <Typography align="center">
          From here, you can manage experiences you’re hosting.
          <br />
          <br />
          Use this dashboard to create new experiences or make changes to existing ones!
        </Typography>
        <Box pt={4} />
        <Box display="flex" justifyContent="center">
          <YellowButton onClick={close}>Got it!</YellowButton>
        </Box>
      </Box>
    </Modal>
  );
}
